export default {
  below: -1,
  normal: 0,
  above: 1,
  floating: 10,
  tooltip: 100,
  menu: 200,
  modal: 1000,
}
